import { auth } from "../firebase-config.js";
import { signOut } from "firebase/auth";

import Cookies from "universal-cookie";

const cookies = new Cookies();

export const AppWrapper = ({ children, isAuth, setIsAuth, setIsInChat }) => {
  const signUserOut = async () => {
    await signOut(auth);
    cookies.remove("auth-token");
    setIsAuth(false);
    setIsInChat(false);
  };

  return (
    <div className="App">
      <div className="app-header">
      </div>

      <div className="app-container">{children}</div>
      {isAuth && (
        <div className="flex justify-center">
          <button className="w-[130px] h-[40px] bg-[#302c28] text-white rounded-md mt-5 cursor-pointer" onClick={signUserOut}> Sign Out</button>
           </div>
      )}
    </div>
  );
};